<!-- @format -->

<template>
  <Loading v-show="show" />

  <!-- new slider start -->
  <div class="slideshow-container" v-show="showSlider">
    <div class="mySlides fade2" v-for="slider in sliders" :key="slider.postId">
      <img
        v-bind:src="'https://api2.yuniv.net:444/images/post/' + slider.postImage"
        style="width: 100%"
      />
      <div class="text">{{ slider.postTitle }}</div>
    </div>
  </div>
  <!-- <br /> -->
  <!-- <div style="text-align:center" v-show="false"> -->
  <span class="dot" v-show="false"></span>
  <!-- </div> -->

  <!-- new slider end  -->

  <!-- News Line Start -->
  <div class="newsletter-area" style="border-radius: 0 !important" v-show="showNewsLine">
    <div class="container">
      <div class="row" style="flex-direction: initial">
        <div class="section_news_index col-lg-3 col-md-3 d-none d-lg-block">
          <div class="newsletter-content">
            <h3 id="h__1">{{ LastNews }}</h3>
          </div>
        </div>
        <div class="col-lg-9 col-sm-12 col-xs-12">
          <div dir="ltr">
            <marquee :direction="direction">
              <span v-for="newstape in NewsTape" :key="newstape.postId">
                <img src="/img/favicon.png" />
                <a target="_blank" :href="newstape.postSubTitle">
                  {{ newstape.postTitle }}</a
                >
              </span>
            </marquee>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- News Line End -->

  <!-- About Start -->
  <div class="about-page-area section-padding" v-show="showAbout" style="padding: 56px 0">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="section-title-wrapper" style="margin-bottom: 19px">
            <div class="section-title">
              <h3>{{ AboutName }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-12">
          <div class="about-text-container">
            <p>
              {{ AboutSub }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- About End -->

  <!-- Know Univ Start -->
  <div
    v-show="showKnowUniv"
    class="latest-area section-padding d-none"
    style="background-color: #3498db; padding: 60px 0 67px"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="section-title-wrapper">
            <div class="section-title">
              <h3 style="margin-bottom: 24px; color: #fff">{{ AboutUs }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          v-for="KnowUniv in KnowUniv"
          :key="KnowUniv.postId"
          class="col-lg-4 col-md-6"
        >
          <div class="single-event-item">
            <div class="single-event-image">
              <a href="javascript:void(0)">
                <img
                  v-bind:src="
                    'https://api2.yuniv.net:444/images/post/' + KnowUniv.postImage
                  "
                />
              </a>
            </div>
            <div class="single-event-text">
              <h6 style="margin-bottom: 10px">
                <a href="javascript:void(0)">{{ KnowUniv.postTitle }}</a>
              </h6>
              <p>{{ KnowUniv.postSubTitle }}</p>

              <router-link
                class="button-default"
                :to="{
                  name: 'Univ-with-id-And-Type',
                  params: {
                    type: 'Univ.Home.Sec.KnowUniv',
                    id: KnowUniv.postID,
                  },
                }"
              >
                {{ Detials }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 text-center">
        <router-link
          :to="{
            name: 'Univ-with-Type',
            params: {
              type: 'Univ.Home.Sec.KnowUniv',
            },
          }"
          class="button-default button-large"
        >
          {{ BtnMore }} <i class="fa fa-chevron-left"></i
        ></router-link>
      </div>
    </div>
  </div>
  <!-- Know Univ End -->

  <!-- Fact start -->
  <div class="fun-factor-area" v-show="showFacts" style="padding: 60px 0 67px">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="section-title-wrapper white">
            <div class="section-title">
              <h3 style="margin-bottom: 24px">{{ impFact }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-for="Facts in Facts" :key="Facts.postId" class="col-lg-3 col-md-3 col-12">
          <div class="single-fun-factor">
            <h4>{{ Facts.postTitle }}</h4>
            <h2>
              {{ Facts.postSubTitle }}
              <!-- <span class="counter">{{ Facts.postSubTitle }}</span> -->
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Fact end -->

  <!-- News start -->
  <div class="latest-area section-padding" v-show="showNews" style="padding: 60px 0 0px">
    <div class="container">
      <div class="row ppppp">
        <div class="col-md-10">
          <div class="section-title-wrapper">
            <div class="section-title">
              <h3 style="margin-bottom: 24px">{{ LastNews }}</h3>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-sm-12" style="text-align: left">
          <router-link
            :to="{
              name: 'News-With-Type-And_BrnId',
              params: {
                type: 'Univ.Home.Sec.News',
                BrnId: 'U',
              },
            }"
            class="button-default button-large"
          >
            {{ BtnMore }} <i class="fa fa-chevron-left"></i
          ></router-link>
        </div>
      </div>
      <div class="row down_nt">
        <div v-for="news in News" :key="news.postId" class="col-lg-4 col-md-6 col-12">
          <div class="single-item">
            <div class="single-item-image overlay-effect">
              <a href="javascript:void(0)"
                ><img
                  v-bind:src="'https://api2.yuniv.net:444/images/post/' + news.postImage"
              /></a>
            </div>
            <div class="single-item-text">
              <h4>
                <a href="javascript:void(0)">{{ news.postTitle }}</a>
              </h4>
              <p>{{ news.postSubTitle }}</p>
            </div>
            <div class="button-bottom">
              <router-link
                class="button-default"
                :to="{
                  name: 'NewsDetails-with-id-And-Type-And-BrnId',
                  params: {
                    type: 'Univ.Home.Sec.News',
                    id: news.postID,
                    BrnId: 'U',
                  },
                }"
              >
                {{ Detials }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- News end -->

  <!-- service start -->
  <div
    v-show="showservices"
    class="latest-area section-padding"
    style="background-color: #3498db; padding: 60px 0 67px"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-10">
          <div class="section-title-wrapper">
            <div class="section-title">
              <h3 style="margin-bottom: 24px; color: #fff">{{ Service }}</h3>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-sm-12" style="text-align: left">
          <router-link
            :to="{
              name: 'Univ-with-Type',
              params: {
                type: 'Univ.Services',
              },
            }"
            class="button-default button-large"
          >
            {{ BtnMore }} <i class="fa fa-chevron-left"></i
          ></router-link>
        </div>
      </div>

      <div class="row">
        <div v-for="servic in services" :key="servic.postID" class="col-lg-3 col-md-6">
          <div class="single-event-item">
            <div class="single-event-image">
              <a href="javascript:void(0)">
                <img
                  v-bind:src="
                    'https://api2.yuniv.net:444/images/post/' + servic.postImage
                  "
                />
              </a>
            </div>
            <div class="single-event-text">
              <h6 style="margin-bottom: 10px">
                <a href="javascript:void(0)">{{ servic.postTitle }}</a>
              </h6>
              <!-- <p>{{ servic.postSubTitle }}</p> -->

              <router-link
                class="button-default"
                :to="{
                  name: 'Service',
                  params: {
                    id: servic.postID,
                  },
                }"
              >
                {{ Detials }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- service end -->

  <!-- testimonials start -->
  <div class="testimonial-area" v-show="showTestimonials" style="padding: 60px 0 60px">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 offset-lg-0 col-md-12 col-12" dir="rtl">
          <div class="row">
            <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2">
              <div class="testimonial-image-slider text-center">
                <div
                  v-for="testimonials in Testimonials"
                  :key="testimonials.postId"
                  class="sin-testiImage"
                >
                  <img
                    v-bind:src="
                      'https://api2.yuniv.net:444/images/post/' + testimonials.postImage
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="testimonial-text-slider text-center" dir="rtl">
            <div
              v-for="testimonials in Testimonials"
              :key="testimonials.postId"
              class="sin-testiText"
            >
              <h2>{{ testimonials.postTitle }}</h2>
              <p>
                {{ testimonials.postSubTitle }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- testimonials end -->

  <!-- Activity start -->
  <div
    class="latest-area section-padding oneon"
    style="padding: 0px 0 60px"
    v-show="showActivity"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-10">
          <div class="section-title-wrapper">
            <div class="section-title">
              <h3 style="margin-bottom: 24px">{{ CollegeActivity }}</h3>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-sm-12" style="text-align: left">
          <router-link
            :to="{
              name: 'Events-With-Type',
              params: {
                type: 'Univ.Activity',
              },
            }"
            class="button-default button-large"
          >
            {{ BtnMore }} <i class="fa fa-chevron-left"></i
          ></router-link>
        </div>
      </div>
      <div class="row">
        <div v-for="event in Events" :key="event.postId" class="col-lg-4 col-md-6 col-12">
          <div class="single-event-item">
            <div class="single-event-image">
              <a href="javascript:void(0)">
                <img
                  v-bind:src="'https://api2.yuniv.net:444/images/post/' + event.postImage"
                />
                <!-- <span
                  ><span>{{ event.day1 }}</span
                  >{{ event.nT_MONTH1 }}</span
                > -->
              </a>
            </div>
            <div class="single-event-text">
              <h6>
                <a href="javascript:void(0)" style="line-height: 2; text-align: justify"
                  >{{ event.postTitle }}
                </a>
              </h6>
              <div class="single-item-comment-view">
                <span><i class="fa fa-clock-o"></i>{{ event.time1 }}</span>
                <span><i class="fa fa-map-pin"></i>{{ event.txtAdress1 }} </span>
              </div>
              <p style="text-align: justify">
                {{ event.postSubTitle }}
              </p>

              <router-link
                class="button-default"
                :to="{
                  name: 'Event-with-id-And-Type',
                  params: {
                    name: 'الأنشطة',
                    type: 'Univ.Activity',
                    id: event.postID,
                  },
                }"
              >
                {{ Detials }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Activity end -->
</template>

<script>
import Loading from "./Loading";

import axios from "axios";
import ArJson from "../../public/i18n/Ar.json";
import EnJson from "../../public/i18n/En.json";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      show: true,
      showSlider: true,
      showAbout: true,
      showFacts: true,
      showNews: true,
      showTestimonials: true,
      showActivity: true,
      showNewsLine: true,
      showKnowUniv: true,
      showservices: true,
      sliders: [],
      NewsTape: [],
      direction: "right",
      AboutName: "",
      AboutSub: "",
      KnowUniv: [],
      Facts: [],
      News: [],
      Testimonials: [],
      Events: [],
      lang: "",
      ArTranslat: ArJson,
      EnTranslat: EnJson,
      translate: "",
      LastNews: "",
      AboutUs: "",
      BtnMore: "",
      impFact: "",
      Detials: "",
      CollegeActivity: "",
      services: [],
      Service: "",
    };
  },
  mounted() {
    var self_ = this;
    if (localStorage.getItem("lang") == null) {
      axios({
        method: "get",
        url: "https://api2.yuniv.net:444/languages/getLangIsMain",
      }).then(function (response) {
        localStorage.setItem("lang", response.data[0]["LangId"]);
        self_.getApis();
      });
    } else self_.getApis();
  },
  methods: {
    getApis() {
      window.scroll(0, 0);
      var self = this;
      var bodyFormData1 = new FormData();

      if (localStorage.getItem("lang") == "Ar") {
        self.translate = self.ArTranslat;
        self.direction = "right";
      } else {
        self.translate = self.EnTranslat;
        self.direction = "left";
        let link1 = document.createElement("link");
        link1.setAttribute("rel", "stylesheet");
        link1.id = "langfilewebsites";
        link1.setAttribute("href", "./style-ltr.css");
        document.head.appendChild(link1);
      }
      self.LastNews = self.translate[0]["Home"]["LastNews"];
      self.AboutUs = self.translate[0]["Home"]["AboutUs"];
      self.BtnMore = self.translate[0]["Home"]["BtnDetials"];
      self.impFact = self.translate[0]["Home"]["impFact"];
      self.Detials = self.translate[0]["Home"]["Detials"];
      self.CollegeActivity = self.translate[0]["Home"]["CollegeActivity"];
      self.Service = self.ArTranslat[0]["HeaderAndFooter"]["Service"];

      bodyFormData1.append("check", "getPost");
      bodyFormData1.append("PostId", "");
      bodyFormData1.append("Lang", localStorage.getItem("lang"));
      bodyFormData1.append("FbrnId", "");
      bodyFormData1.append("Type", "Univ.Home.MainSlider");
      bodyFormData1.append("ParentId", "NTROOT0");
      bodyFormData1.append("PostName", "");
      bodyFormData1.append("Pno", "-1");
      axios({
        method: "post",
        url: "https://api2.yuniv.net:444/our_team/getPost",
        data: bodyFormData1,
      })
        .then(function (response) {
          var arr = response.data;
          if (arr.length == 0) self.showSlider = false;
          else self.showSlider = true;

          self.sliders = response.data;
          var bodyFormData = new FormData();
          bodyFormData.append("check", "getPost");
          bodyFormData.append("PostId", "");
          bodyFormData.append("Lang", localStorage.getItem("lang"));
          bodyFormData.append("FbrnId", "");
          bodyFormData.append("Type", "Univ.Home.Sec.About");
          bodyFormData.append("ParentId", "NTROOT0");
          bodyFormData.append("PostName", "");
          bodyFormData.append("Pno", "1");
          axios({
            method: "post",
            url: "https://api2.yuniv.net:444/our_team/getPost",
            data: bodyFormData,
          })
            .then(function (response) {
              var arr = response.data;
              if (arr.length != 0) {
                self.showAbout = true;
                self.AboutName = response.data[0]["postTitle"];
                self.AboutSub = response.data[0]["postSubTitle"];
              } else {
                self.showAbout = false;
              }
              var bodyFormData = new FormData();
              bodyFormData.append("check", "getPost");
              bodyFormData.append("PostId", "");
              bodyFormData.append("Lang", localStorage.getItem("lang"));
              bodyFormData.append("FbrnId", "");
              bodyFormData.append("Type", "Univ.Home.Sec.KnowUniv");
              bodyFormData.append("ParentId", "NTROOT0");
              bodyFormData.append("PostName", "");
              bodyFormData.append("Pno", "3");
              axios({
                method: "post",
                url: "https://api2.yuniv.net:444/our_team/getPost",
                data: bodyFormData,
              })
                .then(function (response) {
                  self.KnowUniv = response.data;

                  var arr = response.data;
                  if (arr.length != 0) {
                    self.showKnowUniv = true;
                    //   console.log("daata true ");
                  } else {
                    self.showKnowUniv = false;
                    //   console.log("no daata");
                  }

                  var bodyFormData = new FormData();
                  bodyFormData.append("check", "getPost");
                  bodyFormData.append("PostId", "");
                  bodyFormData.append("Lang", localStorage.getItem("lang"));
                  bodyFormData.append("FbrnId", "");
                  bodyFormData.append("Type", "Univ.Home.Sec.Facts");
                  bodyFormData.append("ParentId", "NTROOT0");
                  bodyFormData.append("PostName", "");
                  bodyFormData.append("Pno", "8");
                  axios({
                    method: "post",
                    url: "https://api2.yuniv.net:444/our_team/getPost",
                    data: bodyFormData,
                  })
                    .then(function (response) {
                      self.Facts = response.data;
                      var arr = response.data;
                      if (arr.length != 0) {
                        self.showFacts = true;
                      } else {
                        self.showFacts = false;
                      }

                      var bodyFormData = new FormData();
                      bodyFormData.append("check", "getPost");
                      bodyFormData.append("PostId", "");
                      bodyFormData.append("Lang", localStorage.getItem("lang"));
                      bodyFormData.append("FbrnId", "");
                      bodyFormData.append("Type", "Univ.Home.Sec.News");
                      bodyFormData.append("ParentId", "NTROOT0");
                      bodyFormData.append("PostName", "");
                      bodyFormData.append("Pno", "3");
                      axios({
                        method: "post",
                        url: "https://api2.yuniv.net:444/our_team/getPost",
                        data: bodyFormData,
                      })
                        .then(function (response) {
                          self.News = response.data;
                          var arr = response.data;

                          if (arr.length != 0) {
                            self.showNews = true;
                          } else {
                            self.showNews = false;
                          }
                          var bodyFormData = new FormData();
                          bodyFormData.append("check", "getPost");
                          bodyFormData.append("PostId", "");
                          bodyFormData.append("Lang", localStorage.getItem("lang"));
                          bodyFormData.append("FbrnId", "");
                          bodyFormData.append("Type", "Univ.Home.Sec.Testimonials");
                          bodyFormData.append("ParentId", "NTROOT0");
                          bodyFormData.append("PostName", "");
                          bodyFormData.append("Pno", "6");
                          axios({
                            method: "post",
                            url: "https://api2.yuniv.net:444/our_team/getPost",
                            data: bodyFormData,
                          })
                            .then(function (response) {
                              self.Testimonials = response.data;

                              var arr = response.data;

                              if (arr.length != 0) {
                                self.showTestimonials = true;
                              } else {
                                self.showTestimonials = false;
                              }

                              var bodyFormData = new FormData();
                              bodyFormData.append("check", "getPost");
                              bodyFormData.append("Lang", localStorage.getItem("lang"));
                              bodyFormData.append("FbrnId", "");
                              bodyFormData.append("Type", "Univ.Activity");
                              bodyFormData.append("ParentId", "NTROOT0");
                              bodyFormData.append("PostName", "");
                              bodyFormData.append("Pno", "3");
                              axios({
                                method: "post",
                                url: "https://api2.yuniv.net:444/our_team/getPost",
                                data: bodyFormData,
                              })
                                .then(function (response) {
                                  self.Events = response.data;

                                  var arr = response.data;

                                  if (arr.length != 0) {
                                    self.showActivity = true;
                                  } else {
                                    self.showActivity = false;
                                  }
                                  // services
                                  var bodyFormData = new FormData();
                                  bodyFormData.append("check", "getPost");
                                  bodyFormData.append(
                                    "Lang",
                                    localStorage.getItem("lang")
                                  );
                                  bodyFormData.append("FbrnId", "");
                                  bodyFormData.append("Type", "Univ.Services");
                                  bodyFormData.append("ParentId", "NTROOT0");
                                  bodyFormData.append("PostName", "");
                                  bodyFormData.append("Pno", "4");
                                  axios({
                                    method: "post",
                                    url: "https://api2.yuniv.net:444/our_team/getPost",
                                    data: bodyFormData,
                                  })
                                    .then(function (response) {
                                      self.services = response.data;
                                      //  console.log("ffffet",self.services)
                                      var arr = response.data;

                                      if (arr.length != 0) {
                                        self.showservices = true;
                                      } else {
                                        self.showservices = false;
                                      }

                                      //end services
                                      var bodyFormData = new FormData();
                                      bodyFormData.append("check", "getPost");
                                      bodyFormData.append(
                                        "Lang",
                                        localStorage.getItem("lang")
                                      );
                                      bodyFormData.append("FbrnId", "");
                                      bodyFormData.append("Type", "Univ.Home.NewsLine");
                                      bodyFormData.append("ParentId", "NTROOT0");
                                      bodyFormData.append("PostName", "");
                                      bodyFormData.append("Pno", "10");
                                      axios({
                                        method: "post",
                                        url:
                                          "https://api2.yuniv.net:444/our_team/getPost",
                                        data: bodyFormData,
                                      })
                                        .then(function (response) {
                                          self.NewsTape = response.data;

                                          var arr = response.data;

                                          if (arr.length != 0) {
                                            self.showNewsLine = true;
                                          } else {
                                            self.showNewsLine = false;
                                          }

                                          document
                                            .getElementById("VueMainJsNewTouch")
                                            ?.remove();
                                          let recaptchaScript = document.createElement(
                                            "script"
                                          );
                                          recaptchaScript.setAttribute(
                                            "src",
                                            "/js/main.js"
                                          );
                                          recaptchaScript.id = "VueMainJsNewTouch";
                                          document.head.appendChild(recaptchaScript);
                                          setTimeout(() => {
                                            self.show = false;
                                          }, 100);
                                        })
                                        .catch(function (response) {
                                          console.log("error", response);
                                        });
                                    })
                                    .catch(function (response) {
                                      console.log("error", response);
                                    });
                                })
                                .catch(function (response) {
                                  console.log("error", response);
                                });
                            })
                            .catch(function (response) {
                              console.log("error", response);
                            });
                        })
                        .catch(function (response) {
                          console.log("error", response);
                        });
                    })
                    .catch(function (response) {
                      console.log("error", response);
                    });
                })
                .catch(function (response) {
                  console.log("error", response);
                });
            })
            .catch(function (response) {
              console.log("error", response);
            });
        })
        .catch(function (response) {
          console.log("error", response);
        });
    },
  },
};
</script>

<style scoped>
.oneon {
  margin-top: 60px;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .section_news_index,
  .newsletter-area::before,
  .newsletter-area::after {
    display: none;
  }
}

.slider-area {
  z-index: 0;
}

.newsletter-area {
  background: #3498db none repeat scroll 100% 0;
  color: #ffffff;
  position: relative;
}

.newsletter-form {
  overflow: hidden;
  padding: 7px 0;
}

.newsletter-area:before {
  height: 65px;
  right: 0;
  left: auto;
  top: -13px;
  width: 31%;
}

.newsletter-area:after {
  border-width: 32.5px 27px;
  right: 27%;
  left: auto;
  top: -13px;
}

.newsletter-content {
  padding-top: 0px;
  z-index: 9;
  position: relative;
}

.ticker-left {
  display: inline-block;
  font-weight: bold;
  min-width: 50%;
  margin-top: 0px;
  margin-bottom: -1rem !important;
}

marquee {
  margin-top: 7px;
}

marquee img {
  height: 27px;
  width: 40px;
  padding-right: 5px;
  padding-left: 5px;
}
marquee a {
  color: #fff;
}
.ppppp {
  margin-bottom: 70px;
}
.down_nt {
  margin-bottom: 30px;
}
.single-event-image span {
  display: block;
  font-family: "montserratsemi_bold";
  font-size: 26px;
  text-align: center;
}
.imagesNews_ {
  width: 250px;
  height: 190px;
}

.testimonial-area .container .row {
  flex-direction: column;
}

/* slide css */
.mySlides {
  display: none;
}
/* img {vertical-align: middle;} */

/* Slideshow container */
.slideshow-container {
  width: 100%;
  position: relative;
  margin: auto;
}

/* Caption text */
.text {
  width: 100%;
  color: #f2f2f2;
  margin-bottom: -25px;
  font-size: 25px;
  line-height: 1.7;
  font-family: "Droid Arabic Kufi" !important;
  text-align: center !important;
  padding: 12px 12px;
  position: absolute;
  bottom: 50px;
}

/* The dots/bullets/indicators */
.dot {
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbb;
  border-radius: 50%;
  border-color: black;
  display: inline-block;
  transition: background-color 0.6s ease;
}

.active {
  background-color: #717171;
}

/* Fading animation */
.fade2 {
  -webkit-animation-name: fade;
  -webkit-animation-duration: 1.5s;
  animation-name: fade;
  animation-duration: 1.5s;
}

@-webkit-keyframes fade {
  from {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}

@keyframes fade {
  from {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}

/* On smaller screens, decrease text size */
@media only screen and (max-width: 750px) {
  .text {
    font-size: 11px !important;
  }
}
</style>
